import React from 'react';
// ANTD
import Col from 'components/common/Col';
import Row from 'components/common/Row';

import EmailTemplateDropdown from 'components/inputs/EmailTemplateDropdown';

class ChooseEmailTemplateButton extends React.PureComponent {
  state = {
    showForm: false,
  };

  onChange = val => {
    this.props.onTemplateSelected(val);
    this.onToggleForm();
  };

  onToggleForm = () => {
    this.setState({ showForm: !this.state.showForm });
  };

  render() {
    return (
      <div>
        <div style={{ paddingTop: 5, paddingBottom: 5 }}>
          {!this.state.showForm && <a onClick={this.onToggleForm}>Choose a Saved Template</a>}
        </div>
        {this.state.showForm && (
          <Row style={{ paddingTop: 15, paddingBottom: 15 }}>
            <Col xs={20} style={{ justifyConent: 'center', alignItems: 'center' }}>
              <EmailTemplateDropdown onChange={this.onChange} />
            </Col>
            <Col xs={4} style={{ textAlign: 'center', justifyConent: 'center', alignItems: 'center' }}>
              <a onClick={this.onToggleForm} style={{ marginTop: 5, fontSize: 12 }}>
                Cancel
              </a>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default ChooseEmailTemplateButton;



// WEBPACK FOOTER //
// ./src/components/common/ChooseEmailTemplateButton/index.js